import React from 'react';
import { ActivityIndicator, Pressable, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

export default function WorkTaskLoadingNotice({ unavailable, onRetry }) {
  const { colors } = useTheme();
  return <View style={{ gap: 10, padding: 20, borderRadius: 18, borderWidth: 1,
    borderColor: colors.border_color_secondary, backgroundColor: colors.solid_color_block }}>
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
      {!unavailable && <ActivityIndicator size="small" color={colors.text_color_secondary} />}
      <Text size="m" weight="medium" accessibilityLiveRegion="polite">
        {unavailable ? 'Unable to load task details' : 'Loading task details…'}
      </Text>
    </View>
    <Text size="s" color="secondary">You can keep reading this chat.</Text>
    {unavailable && <Pressable accessibilityRole="button" accessibilityLabel="Retry loading task details" onPress={onRetry}
      style={({ pressed }) => ({ alignSelf: 'flex-start', paddingVertical: 10, paddingHorizontal: 16,
        borderRadius: 12, borderWidth: 1, borderColor: colors.border_color_secondary, opacity: pressed ? 0.6 : 1 })}>
      <Text size="s" weight="medium">Try again</Text>
    </Pressable>}
  </View>;
}
